import { RootState } from 'src/redux/root'

export const selectRuntimeErrors = (state: RootState) => {
  const runtimeErrors = [
    state.analysis.runtimeError,
    state.upgrades.runtimeError,
    state.umibuilder.runtimeError,
    state.project.runtimeError,
    // state.user.runtimeError,
    // state.asyncTasks.runtimeError,
    // state.error.runtimeError,
    // state.navigation.runtimeError,
  ]
  const message = runtimeErrors.some((err) => err) ? 'An error occurred in a Redux Reducer!' : null
  return message ? { message } : null
}

export const selectError = (state: RootState) => {
  const runtimeError = selectRuntimeErrors(state)
  const mainError = state.error.error
  if (mainError) {
    return mainError
  } else {
    return runtimeError
  }
}
